import React, { useState } from 'react';

import { FlexBox } from 'ml-rubiks-styleguide/src/box';
import { Checkbox } from 'ml-rubiks-styleguide/src/checkbox';

import { useI18n } from '../../contexts/i18n-context';

interface BacsConsentCheckboxProps {
    onChange: (checked: boolean) => void;
}

export const BacsConsentCheckbox: React.FC<BacsConsentCheckboxProps> = ({
    onChange
}) => {
    const { t } = useI18n();
    const [checked, setChecked] = useState(false);

    const handleChange = (newChecked: boolean) => {
        setChecked(newChecked);
        onChange(newChecked);
    };

    return (
        <FlexBox padding={[0, 2]}>
            <Checkbox
                labelProps={{
                    sx: {
                        alignItems: 'flex-start'
                    }
                }}
                checked={checked}
                onChange={handleChange}
                label={t(
                    'upc.bacs.consent',
                    'This guarantee is offered by all Banks & Building Societies that take part in the Direct Debit Scheme. The efficiency and security of the Scheme is monitored and protected by your own Bank or Building Society. If the amounts to be paid or the payment dates change we will notify you 10 working days in advance of your account being debited or as otherwise agreed. If an error is made by your Fitness Studio, or your Bank or Building Society, you are guaranteed a full and immediate refund from your branch of the amount paid. You can cancel a Direct Debit at any time by writing to your Bank or Building Society, please also send a copy of the letter to us.'
                )}
            />
        </FlexBox>
    );
};
